<template>
  <el-input
    v-model="elValue"
    class="number-input"
    :class="hasError && 'has-error'"
    :disabled="disabled"
    @blur="handleInput"
    @focus="onFocus"
    @keypress.enter.native="handleInput"
  >
    <i v-if="customIcon" :slot="customIcon.placement" class="el-input__icon" :class="customIcon.class"></i>
  </el-input>
</template>

<script>
import { formatBigNumber } from '@/components/filters'

export default {
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      required: true
    },
    min: {
      type: Number,
      default: null
    },
    max: {
      type: Number,
      default: null
    },
    skipValidate: {
      type: Array,
      default: null
    },
    disabled: {
      type: Boolean,
      default: false
    },
    customIcon: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      elValue: null,
      hasError: false
    }
  },
  computed: {
    valueWatcher () {
      return this.value
    }
  },
  created () {
    this.elValue = formatBigNumber(this.value)
  },
  methods: {
    onFocus () {
      this.hasError = false
    },
    showError () {
      this.hasError = true
      this.scrollIntoView()
    },
    handleInput () {
      if (this.disabled) {
        return
      }
      let value = (this.elValue + '').replace(/,/g, '')
      if (isNaN(value)) {
        this.$message.error(this.$t('admin.job.referral.message.needInputNumber'))
        this.showError()
        return
      }
      value = parseInt(value) || 0
      if (!this.skipValidate || !this.skipValidate.includes(value)) {
        if (this.min !== null && value < this.min) {
          this.$message.error(this.$t('admin.job.referral.message.inputNumberMustBigger', { number: this.min }))
          this.showError()
          return
        }
        if (this.max !== null && value > this.max) {
          this.$message.error(this.$t('admin.job.referral.message.inputNumberMustSmaller', { number: this.max }))
          this.showError()
          return
        }
      }
      this.hasError = false
      this.elValue = formatBigNumber(value)
      this.$emit('change', value)
    },
    scrollIntoView () {
      this.$el.scrollIntoView({ block: 'center', behavior: 'smooth' })
    }
  },
  watch: {
    valueWatcher () {
      this.elValue = formatBigNumber(this.value)
    }
  }
}
</script>

<style lang="scss" scoped>
.number-input {
  &.has-error {
    ::v-deep {
      .el-input__inner {
        border-color:#c60000;
        background-color: #c60000;
        color: #fff;
      }
    }
  }

  &.is-disabled {
    ::v-deep {
      .el-input__inner {
        border-color:#b2b2b2;
        background-color: #f9f9f9;
        color: #606266;
      }
    }
  }

  &.el-input--prefix {
    ::v-deep {
      .el-input__inner {
        padding-left: 20px;
      }
    }
  }
}
</style>
